<action class="p-r-2 p-r-3-s p-l-2 p-l-3-s b-radius-max button-1 button-size-2 b-col-4-i"
        (click)="logout()"
        [status]="logoutStatus"
        sl-button="logout">
    {{'Sign out' | translate}}
</action>

<result [status]="logoutStatus"
        sl-result="logout"
        class="block m-t-1" />